export { KioskPage } from './KioskPage'
